import {useEffect, useRef} from 'react';
import {useReportStore} from "../useReportStore";

/**
 * Custom hook that manages the browser document title.
 * Sets the title to the report title and restores it on unmount.
 */
export const useDocumentTitle = () => {
    const title = useReportStore(s => s.title);
    const prevTitleRef = useRef(typeof document !== 'undefined' ? document.title : '');

    // Set initial title when report is loaded
    useEffect(() => {
        if (typeof document === 'undefined') return;

        // Store the previous title
        prevTitleRef.current = document.title;

        // Restore previous title on cleanup
        return () => {
            try {
                document.title = prevTitleRef.current;
            } catch (err) {
                // ignore
            }
        };
    }, []);

    // Update document.title whenever the report title in the store changes
    useEffect(() => {
        if (typeof document === 'undefined') return;

        try {
            if (title) {
                document.title = title;
            }
        } catch (err) {
            console.error('Failed to update document.title from store title:', err);
        }
    }, [title]);
};
